require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-user-journey-mapping.json") })
        }
      }, "path---workshops-user-journey-mapping");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-user-journey-mapping!./.cache/json/workshops-user-journey-mapping.json
// module id = 515
// module chunks = 231608221292675